import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Modal from '../Modal/Modal';

import ProductInfo from '../ProductInfo/ProductInfo';
import ProductSkeleton from '../../routes/product/ProductSkeleton';
import { getProductSingle } from '../../actions/product';
// eslint-disable-next-line css-modules/no-unused-class
import s from './ProductInfoModal.scss';
// eslint-disable-next-line css-modules/no-unused-class
import cardStyle from '../Card/Card.scss';

const ProductInfoModal = ({
  productId,
  product,
  dispatch,
  children,
  hoverType,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleModalClick = async () => {
    if (modalVisible) {
      setModalVisible(false);
      return;
    }
    setModalVisible(true);
    await dispatch(getProductSingle(productId));
  };

  return (
    <Modal
      fullScreen
      divider
      animation="slideRight"
      handleClick={handleModalClick}
      isVisible={modalVisible}
      className={s.root}
      triggerProps={{
        children,
        className: cx(
          cardStyle.wrapper,
          s.productCardButton,
          hoverType && cardStyle[`hover-type--${hoverType}`],
        ),
      }}
    >
      {product.loading ? (
        <ProductSkeleton />
      ) : (
        <ProductInfo className={s.content} />
      )}
    </Modal>
  );
};

ProductInfoModal.propTypes = {
  productId: PropTypes.string.isRequired,
  product: PropTypes.shape().isRequired,
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  hoverType: PropTypes.string.isRequired,
};

const mapState = state => ({
  product: state.product,
});

export default compose(
  connect(mapState),
  withStyles(s, cardStyle),
)(ProductInfoModal);
